import { forwardRef } from '@chakra-ui/react';
import { Button, ButtonProps } from '@chakra-ui/react';
import React from 'react';

type ButtonColor = 'red' | 'darkBlue' | 'gray' | 'black' | 'teal';

type Props = {
  colorScheme?: ButtonColor;
} & ButtonProps;

export const CmButton = forwardRef<Props, 'button'>(
  // @ts-ignore TS2590
  (
    {
      children,
      variant = 'solid',
      px = '5',
      colorScheme = 'darkBlue',
      ...rest
    },
    ref
  ) => {
    return (
      // @ts-ignore TS2590
      <Button {...{ ...rest, colorScheme, variant, px, ref }}>
        {children}
      </Button>
    );
  }
);
